module.exports = __webpack_public_path__ + "static/health-smart-behavior-body-2-bd48883fbd170df4bad12dd14b9841a9.jpg";